exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._1cJMS1_GbBhY2o-nbbajH0{margin-left:12px!important}html[dir=rtl] ._1cJMS1_GbBhY2o-nbbajH0{margin-right:12px!important}html[dir] .Gf6FgM99ZJ9S8H48pFMdB{border-radius:4px!important}._3ZsIDgzBOGnsAQy-jF1mBE{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}html[dir] .qWLxdNhAHDcSohHI5Zva-{margin:0}._1y8YJ1XNBkLjckwryuEz2e{display:-webkit-box;display:-ms-flexbox;display:flex;color:var(--white)!important}", ""]);
// Exports
exports.locals = {
	"newMessageButtonMargins": "_1cJMS1_GbBhY2o-nbbajH0",
	"newMessageButtonWithIcon": "Gf6FgM99ZJ9S8H48pFMdB",
	"newMessageButtonWithDropDown": "_3ZsIDgzBOGnsAQy-jF1mBE",
	"newSplitMessageButton": "qWLxdNhAHDcSohHI5Zva-",
	"newMessageButtonIcon": "_1y8YJ1XNBkLjckwryuEz2e"
};